import React from 'react';
import { Message } from 'semantic-ui-react';

const Announcements = ({ announcements }) => {
    return announcements.map((announcement, i) => (
            <div key={i}>
                <Message info={i % 2 === 0}>
                    <Message.Header>{announcement.name}</Message.Header>
                    <p>{announcement.description}</p>
                </Message>
            </div>
        ));
};

export default Announcements;
